export const Pages = {
	types:        'types',
	logs:         'logs',
	scopes:       'scopes',
	managedProps: 'managedProps',
	view:         'view',
	permissions:  'permissions',
	emailFiling:  'emailFiling',
	admins:       'admins',
	account:      'account',
} as const;
